import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import axios from 'axios';
import { vendorUrlRegexPath, withPimURL } from 'src/helpers/service';

export interface IVendorDataResponse {
  id: number;
  title: string;
  slug: string;
  dispatchTime: number;
  vacationAt: string | null;
  autoReturnApproveDayCount: number;
  orderAutoApprove: boolean;
  productAutoApprove: boolean;
  orderAutoApproveTime: number;
  minBasketAmount: number;
  orderQuestionDayCount: number;
  approvedAt: string;
  hasPermissionAllCategories: boolean;
  hasPermissionAllBrands: boolean;
  legalEntityTitle: string;
  taxDepartment: string;
  taxNumber: string;
  identityNumber: any;
  iban: string;
  mersisNumber: string;
  kepAddress: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  contactPhone: string;
  contactFixedPhone: any;
  active: boolean;
  isAlternativeCargoAvailable: boolean;
  denyReturnRequest: boolean;
  isVerified: boolean;
  declineProductQuestion: boolean;
  declineOrderQuestion: boolean;
  logoUrl: string;
  canFastListingToBookCategory: boolean;
  onboardingCompletedAt: string;
  isZoneVendor: boolean;
  referenceCode: any;
  onboardingRequestId: any;
  isPlatformAgreement: boolean;
  vendorPassiveReason: any;
  force2fa: boolean;
  enabled2fa: boolean;
  offerEnabled: boolean;
  vendorScore: number;
  canSetMinimumPurchasableQuantity: boolean;
  isProductDescriptionUpdate: boolean;
  landingPage: boolean;
  isBrandRestriction: boolean;
  taxFree: boolean;
  activityStatus: boolean;
  withholdingTaxExemptionDate: any;
  paymentPauseReason: any;
  customizable: boolean;
  referenceSource: any;
  enablePriceMultiplier: boolean;
  isInternationalSeller: boolean;
  vacationUpdatedBy: any;
  flashSaleProduct: boolean;
  flashSaleVisible: boolean;
  isGroupSales?: boolean;
  biSuggestProductExist?: boolean;
  /** "allowed" ise esnek taksit modeli menü/aksiyonları gösterilir */
  installmentPolicyPermission?: string;
}

export default function useVendorData(options: { enabled?: boolean } = {}) {
  const getVendorData = useQuery({
    queryKey: ['get-vendor-info'],
    queryFn: () => {
      return axios.get<IVendorDataResponse>(withPimURL(vendorUrlRegexPath('/vendor/:vendorId/show'))).then((res) => res.data);
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 60 * 1_000,
    cacheTime: 60 * 1_000,
    enabled: typeof options?.enabled === 'boolean' ? options.enabled : true,
  });

  const _checkField = useCallback(
    (field: keyof IVendorDataResponse, exactValue: any, options: { fallback?: boolean } = {}) => {
      const { fallback = false } = options;
      if (getVendorData.status !== 'success') return fallback;

      const fieldValue = getVendorData.data?.[field];
      if (typeof fieldValue !== typeof exactValue) return fallback;

      return fieldValue === exactValue;
    },
    [getVendorData],
  );

  return { ...getVendorData, _checkField };
}
